import { faArrowRight, faSortNumericUpAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { NumberAnswerValue } from "consumerhouse-shared";
import { NumberConditionValue } from "consumerhouse-shared";
import { NumberQuestionOptions } from "consumerhouse-shared";
import { FormRow, RawFormInput, RawFormSelect } from "../FormElements";
import { GroupContainer } from "../GroupContainer";
import { ConditionEditProps, OptionsEditProps, QuestionContainer, QuestionDefinition, QuestionProps } from "../QuestionAnswer";
import styled from "styled-components";
import { useLanguage } from "../../useLanguage";

export const NumberQuestionDefinition: QuestionDefinition<NumberQuestionOptions> = {
    icon: faSortNumericUpAlt,
    defaultOptions: {
        max: 100,
        min: 0,
    },
    questionComponent: NumberQuestion,
    optionsEditComponent: NumberOptionsEdit,
    conditionEditComponent: NumberConditionEdit,
};

function NumberQuestion(props: QuestionProps<NumberQuestionOptions, NumberAnswerValue>) {
    let { min, max } = props.question.optionsJson ?? { min: 0, max: 100 };
    const [value, setValue] = useState(props.value?.value ?? "");
    const language = useLanguage();
    return (
        <QuestionContainer>
            <RawFormInput
                style={{ width: "100px" }}
                disabled={props.readOnly}
                type="number"
                placeholder={language("number")}
                required
                min={min}
                max={max}
                step={1}
                value={value}
                onChange={(ev) => setValue(parseInt(ev.target.value))}
                onBlur={(ev) => {
                    let value = parseInt(ev.target.value);
                    if (value < min) value = min;
                    if (value > max) value = max;
                    let val: NumberAnswerValue = {
                        value: value,
                    };
                    props.onChange(val);
                }}
            />
        </QuestionContainer>
    );
}

function NumberOptionsEdit(props: OptionsEditProps<NumberQuestionOptions>) {
    const options = props.options ?? { min: 0, max: 100 };
    return (
        <GroupContainer title="Bereik" color="#5a8ee8">
            <FormRow>
                <RawFormInput
                    type="number"
                    defaultValue={options.min}
                    style={{ width: "120px" }}
                    onChange={(ev) =>
                        props.onChange({
                            ...options,
                            min: parseInt(ev.target.value),
                        })
                    }
                />
                <FontAwesomeIcon style={{ margin: "0 1em" }} icon={faArrowRight} />
                <RawFormInput
                    type="number"
                    defaultValue={options.max}
                    style={{ width: "120px" }}
                    onChange={(ev) =>
                        props.onChange({
                            ...options,
                            max: parseInt(ev.target.value),
                        })
                    }
                />
            </FormRow>
        </GroupContainer>
    );
}

function NumberConditionEdit(props: ConditionEditProps<NumberConditionValue>) {
    const value: NumberConditionValue = props.condition.valueJson ?? { operator: "min", min: 0 };
    value.operator = value.operator || "min";
    return (
        <div>
            <RawFormSelect
                style={{ margin: "0 0.5em 0 0" }}
                onChange={(ev) => {
                    props.onChange({ ...value, operator: ev.target.value as any });
                }}>
                <option value="min">Minimum</option>
                <option value="max">Maximum</option>
            </RawFormSelect>
            {value.operator === "min" && (
                <RawFormInput
                    type="number"
                    value={value.min ?? 0}
                    onChange={(ev) => props.onChange({ operator: "min", min: parseFloat(ev.target.value) })}
                />
            )}
            {value.operator === "max" && (
                <RawFormInput
                    type="number"
                    value={value.max ?? 0}
                    onChange={(ev) => props.onChange({ operator: "max", max: parseFloat(ev.target.value) })}
                />
            )}
        </div>
    );
}
